import { supabase } from './supabase';

/**
 * Wrapper em torno do fetch que injeta automaticamente o token JWT (Bearer)
 * da sessão atual do Supabase.
 * @param url URL da requisição (relativa ou absoluta)
 * @param options Opções padrão do fetch
 */
export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error || !session) {
        throw new Error('Usuário não autenticado ou sessão expirada.');
    }

    const headers = new Headers(options.headers || {});
    headers.set('Authorization', `Bearer ${session.access_token}`);
    
    // Set Content-Type to JSON if not explicitly omitted or set
    if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
        headers.set('Content-Type', 'application/json');
    }

    return fetch(url, {
        ...options,
        headers,
    });
}

/**
 * Extrai a mensagem de erro detalhada retornada no corpo JSON por uma Edge Function do Supabase
 * em vez de retornar a mensagem genérica 'Edge Function returned a non-2xx status code'.
 */
export async function getEdgeFunctionErrorMessage(error: any, fallbackMessage = 'Erro no processamento da solicitação'): Promise<string> {
    if (!error) return fallbackMessage;

    // Se o erro tiver a propriedade context com o Response da Edge Function
    if (error.context && typeof error.context.json === 'function') {
        try {
            const body = await error.context.json();
            if (body?.error) return body.error;
            if (body?.message) return body.message;
        } catch {
            // Caso o body não seja JSON ou já tenha sido lido
        }
    }

    return error.message || fallbackMessage;
}

